const NAMESPACE = "dataFieldTypes";

const KEYS = {
    Unknown: "Unknown",
    String: "String",
    Integer: "Integer",
    Decimal: "Decimal",
    Boolean: "Boolean",
    Choice: "Choice",
    DateTime: "DateTime",
    User: "User",
    Location: "Location",
    Timestamp: "Timestamp",

    Name: "Name",
    Address: "Address",
    PVSystem: "PVSystem",
    Contact: "Contact",
    IncentiveSelector: "IncentiveSelector",
    CustomList: "CustomList",
    Sensitive: "Sensitive",
    Table: "Table",
    EnergyStorageSystem: "EnergyStorageSystem",
    ProjectTable: "ProjectTable"
};
const MESSAGES = {
    [KEYS.Unknown]: {
        value: "Unknown",
        comment: "Description for an unknown field type"
    },
    [KEYS.String]: {
        value: "String",
        comment: "Description for the String field type"
    },
    [KEYS.Integer]: {
        value: "Integer",
        comment: "Description for the Integer field type"
    },
    [KEYS.Decimal]: {
        value: "Decimal",
        comment: "Description for the Decimal field type"
    },
    [KEYS.Boolean]: {
        value: "Boolean",
        comment: "Description for the Boolean field type"
    },
    [KEYS.Choice]: {
        value: "Choice",
        comment: "Description for the Choice field type"
    },
    [KEYS.DateTime]: {
        value: "Date",
        comment: "Description for the Date field type"
    },
    [KEYS.User]: {
        value: "User",
        comment: "Description for the User field type"
    },
    [KEYS.Location]: {
        value: "Location",
        comment: "Description for the Location field type"
    },
    [KEYS.Timestamp]: {
        value: "Timestamp",
        comment: "Description for the Timestamp field type"
    },

    [KEYS.Name]: {
        value: "Name",
        comment: "Description for the Name field group type"
    },
    [KEYS.Address]: {
        value: "Address",
        comment: "Description for the Address field group type"
    },
    [KEYS.PVSystem]: {
        value: "PV System",
        comment: "Description for the PV System field group type"
    },
    [KEYS.Contact]: {
        value: "Contact",
        comment: "Description for the Contact field group type"
    },
    [KEYS.IncentiveSelector]: {
        value: "Incentive Selector",
        comment: "Description for the Incentive Selector field group type"
    },
    [KEYS.CustomList]: {
        value: "Custom List",
        comment: "Description for the Custom List field group type"
    },
    [KEYS.Sensitive]: {
        value: "Sensitive",
        comment: "Description for the Sensitive Data field group type"
    },
    [KEYS.Table]: {
        value: "Table",
        comment: "Description for the Table field group type"
    },
    [KEYS.EnergyStorageSystem]: {
        value: "Energy Storage System",
        comment: "Description for the Energy Storage System field group type"
    },
    [KEYS.ProjectTable]: {
        value: "Project Table",
        comment: "Description for the Project Table field group type"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
